module.exports = __webpack_public_path__ + "img/H2.3d95192f.png";